import { Facebook, Instagram } from "lucide-react";
import { FACEBOOK_URL, INSTAGRAM_URL } from "./Header";

export const Footer = () => (
  <footer className="bg-mm-ink text-mm-paper py-12" data-testid="site-footer">
    <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row md:items-center justify-between gap-6 text-sm">
      <p><span className="disp text-xl">MM4S</span> · Scolarité • Santé • Sécurité • Solidarité</p>
      <p>Des questions pour aujourd'hui, Une France pour demain</p>
      <span className="flex flex-col gap-2">
        <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link"
          className="inline-flex items-center gap-2 font-bold hover:text-mm-gold transition-colors">
          <Instagram className="w-5 h-5" /> @mm4s2026
        </a>
        <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook-link"
          className="inline-flex items-center gap-2 font-bold hover:text-mm-gold transition-colors">
          <Facebook className="w-5 h-5" /> mm44s2026
        </a>
      </span>
      <p>Un citoyen qui parle en son nom. Sans parti.</p>
    </div>
  </footer>
);
